import { styled } from "@schaeffler-commerce/design-system";
import { Price as PriceV3, type PriceProps } from "~/domains/pricing/components/Price/v3/Price";
import { FontSize, getFontStyle } from "@schaeffler-commerce/design-system";

/**
 * Styled price component for displaying current/sale prices.
 * When soldOut is true, displays with secondary styling and strikethrough.
 */
export const CurrentPrice = styled(PriceV3, {
  shouldForwardProp: (prop) => prop !== "soldOut",
})<PriceProps & { soldOut?: boolean }>(({ soldOut, theme }) => ({
  fontWeight: soldOut ? "normal" : "bold",
  color: soldOut ? theme.palette.text.secondary : theme.palette.text.primary,
  textDecoration: soldOut ? "line-through" : "none",
}));

/**
 * Styled price component for displaying old/crossed-out prices.
 * When soldOut is true, displays as primary with bold (inverted behavior).
 */
export const OldPrice = styled(PriceV3, {
  shouldForwardProp: (prop) => prop !== "soldOut",
})<PriceProps & { soldOut?: boolean }>(({ soldOut, theme }) => ({
  ...getFontStyle(FontSize.BodySmall),
  color: soldOut ? theme.palette.text.primary : theme.palette.text.secondary,
  fontWeight: soldOut ? "bold" : "normal",
  textDecoration: soldOut ? "none" : "line-through",
}));
